import styled, { css } from 'styled-components';

import arrowDown from '~/assets/icons/arrow_down.svg';
import cross from '~/assets/icons/cross.svg';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
`;

const StyledArrowDown = styled.img.attrs({
	src: arrowDown,
	width: 14,
	height: 14,
})<{ $active?: boolean }>`
	position: absolute;
	top: 13px;
	right: 20px;
	rotate: ${(props) => props.$active && '180deg'};
	opacity: 0.5;
	transform-origin: center;
	transition:
		opacity 0.3s ease,
		filter 0.3s ease;
	user-select: none;
	pointer-events: none;
`;

const StyledTopContainer = styled.div<{
	$focus?: boolean;
	$selected?: boolean;
}>`
	position: relative;
	z-index: ${(props) => (props.$focus ? 4 : 2)};
	padding: 12px 20px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;

	${Text} {
		color: #ffffff;
		font-size: 14px;
		font-weight: 400;
	}

	${(props) =>
		props.$selected
			? css`
					background-color: #2d70da;

					${Text} {
						color: #ffffff;
					}
			  `
			: css`
					&:hover {
						background-color: #ffffff;

						${Text} {
							color: #000000;
						}

						${StyledArrowDown} {
							filter: invert(100%);
							opacity: 1;
						}
					}

					${props.$focus &&
					css`
						background-color: #ffffff;

						${Text} {
							color: #000000;
						}

						${StyledArrowDown} {
							filter: invert(100%);
							opacity: 1;
						}
					`}
			  `}
`;

const StyledCross = styled.img.attrs({
	src: cross,
	width: 14,
	height: 14,
})`
	position: absolute;
	top: 50%;
	right: 20px;
	transform: translateY(-50%);
	cursor: pointer;
	user-select: none;
`;

const StyledItemsContainer = styled.div`
	position: absolute;
	top: calc(100% + 10px);
	width: 100%;
	max-height: 200px;
	display: flex;
	flex-direction: column;
	background-color: rgba(255, 255, 255, 0.95);
	overflow-y: auto;
	z-index: 4;
	border-radius: 10px;
	opacity: 0;

	transition: opacity 0.3s ease;

	&.results-enter {
		opacity: 0;
	}

	&.results-enter-active,
	&.results-enter-done,
	&.results-exit {
		opacity: 1;
	}

	&.results-exit-active {
		opacity: 0;
	}

	&::-webkit-scrollbar {
		width: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: transparent;
		transition: background-color 0.3s ease;

		&:hover {
			background-color: rgba(0, 0, 0, 1);
		}
	}
`;

const StyledSelectItem = styled.div`
	padding: 20px 0;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);

	${Text} {
		color: #000000;
		font-size: 14px;
		font-weight: 400;
	}
`;

const StyledSelectItemWrapper = styled.div<{
	$disabled?: boolean;
	$scrollbar?: boolean;
}>`
	padding: ${(props) => (props.$scrollbar ? '0 10px 0 20px' : '0 20px')};
	background-color: transparent;
	transition: background-color 0.3s ease;

	${(props) =>
		!props.$disabled &&
		css`
			&:hover {
				background-color: #000000;

				${StyledSelectItem} {
					${Text} {
						color: #ffffff;
					}
				}
			}
		`}

	${(props) =>
		!props.$disabled &&
		css`
			&,
			& * {
				cursor: pointer;
			}
		`}
`;

const StyledBackWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 3;
	width: 100%;
	height: 100%;
`;

export {
	StyledContainer,
	StyledTopContainer,
	StyledArrowDown,
	StyledCross,
	StyledItemsContainer,
	StyledSelectItemWrapper,
	StyledSelectItem,
	StyledBackWrapper,
};
